import React from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
const VehicleinoutDetailModal = ({ show, onHide, vehicleinout }) => {
  if (!vehicleinout) return null;

  const formatDateTime = (dateString) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Date(dateString).toLocaleString(undefined, options);
  };
  const LiveLocation = ({ coordinates }) => {
    const [address, setAddress] = React.useState(null);

    React.useEffect(() => {
      const fetchAddress = async () => {
        if (!coordinates?.latitude || !coordinates?.longitude) {
          setAddress("No coordinates available");
          return;
        }
        try {
          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coordinates.latitude},${coordinates.longitude}&key=${process.env.REACT_APP_BASE_API}`
          );
          const data = await res.json();
          if (data.status === "OK" && data.results.length > 0) {
            setAddress(data.results[0].formatted_address);
          } else {
            setAddress("Address not found");
          }
        } catch (err) {
          console.error("Error fetching address:", err);
          setAddress("Error fetching address");
        }
      };

      fetchAddress();
    }, [coordinates]);

    return <span>{address || "Fetching address..."}</span>;
  };

  const renderTimings = () => {
    if (!Array.isArray(vehicleinout.vehicleTimings)) return null;

    // ① include all four event‑types now
    const relevantTimings = vehicleinout.vehicleTimings.filter((t) =>
      [
        "left assigned_location",
        "arrived assigned_location",
        "left charging_location",
        "arrived charging_location",
      ].includes(t.type)
    );

    return (
      <div className="timeline">
        {relevantTimings.map((timing, index) => {
          const isLast = index === relevantTimings.length - 1;

          // ② choose label + icon for each type
          let label = "";
          let icon = "";
          switch (timing.type) {
            case "left assigned_location":
              label = "Left Assigned Location";
              icon = "🚗";
              break;
            case "arrived assigned_location":
              label = "Arrived Assigned Location";
              icon = "📍";
              break;
            case "left charging_location":
              label = "Left Charging Location";
              icon = "🔌";
              break;
            case "arrived charging_location":
              label = "Arrived Charging Location";
              icon = "⚡";
              break;
            default:
              label = timing.type;
          }
          {
            <div className="timeline-location">
              {timing.liveCoordinates ? (
                <LiveLocation coordinates={timing.liveCoordinates} />
              ) : (
                timing.chargingLocation ||
                timing.assignedlocation ||
                timing.liveLocation ||
                "-"
              )}
            </div>;
          }

          return (
            <div
              key={index}
              className={`timeline-item ${isLast ? "last-item" : ""}`}
            >
              <div className="timeline-icon">{icon}</div>
              <div className="timeline-content">
                <div className="timeline-label">
                  <b>
                    Step {index + 1}: {label}
                  </b>
                </div>
                <div className="timeline-location">
                  {timing.liveCoordinates ? (
                    <LiveLocation
                      coordinates={timing.liveCoordinates}
                      id={index}
                    />
                  ) : (
                    timing.chargingLocation ||
                    timing.assignedlocation ||
                    timing.liveLocation ||
                    "-"
                  )}
                </div>

                {/* <div className="timeline-location">{location}</div> */}
                <div className="timeline-details">
                  🕒 {formatDateTime(timing.time)}
                  <br />
                  🔋 Battery&nbsp;: {timing.batteryPercentage ?? "--"}%
                  <br />
                  🚗 KM&nbsp;Driven&nbsp;: {timing.kmDriven ?? "--"}
                </div>
              </div>
              {!isLast && <div className="timeline-connector"></div>}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Vehicle In/Out Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Vehicle Number: {vehicleinout.numberplate}</h5>
        {renderTimings()}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>

      {/* Timeline Styles */}
      <style jsx>{`
        .timeline {
          position: relative;
          padding-left: 30px;
        }
        .timeline-item {
          position: relative;
          padding-bottom: 30px;
        }
        .timeline-item.last-item {
          padding-bottom: 0;
        }
        .timeline-icon {
          position: absolute;
          left: -16px;
          top: 0;
          background-color: #fff;
          color: #4723d9;
          border: 2px solid #4723d9;
          border-radius: 50%;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          z-index: 1;
        }
        .timeline-connector {
          position: absolute;
          left: -1px;
          top: 28px;
          height: calc(100% - 28px);
          width: 2px;
          background-color: #ccc;
        }
        .timeline-content {
          margin-left: 20px;
          padding: 5px 10px;
          background: #f9f9f9;
          border-radius: 6px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        .timeline-label {
          font-weight: 600;
          font-size: 1rem;
          margin-bottom: 4px;
        }
        .timeline-location {
          font-size: 0.95em;
          color: #333;
        }
        .timeline-details {
          font-size: 0.85em;
          color: #555;
          margin-top: 4px;
        }
      `}</style>
    </Modal>
  );
};

export default VehicleinoutDetailModal;
